import { Checkbox, CheckboxProps, Flex, HStack, Text } from '@chakra-ui/react';
import { DayOfWeek } from '@prisma/client';
import { useFormContext } from 'react-hook-form';

import { DAYS_OF_WEEK } from '../utils/constants';
import { SimpleField, SimpleXProps } from './SimpleField';

type SimpleCheckboxProps = SimpleXProps &
  CheckboxProps & {
    fieldLabel?: string;
  };

export const SimpleWeekdaySelect = ({ name, fieldLabel = '', size, ...rest }: SimpleCheckboxProps) => {
  const { watch, setValue } = useFormContext();
  const value: DayOfWeek[] = watch(name) || [];

  const toggle = (day: DayOfWeek) => {
    if (value.includes(day)) {
      setValue(
        name,
        value.filter((d) => d !== day),
        {
          shouldDirty: true,
          shouldTouch: true,
        },
      );
    } else {
      setValue(name, [...value, day], {
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  };

  const DayCheckbox = ({ day }: { day: DayOfWeek }) => {
    return (
      <Flex direction="column">
        <Text>{day[0]}</Text>
        <Checkbox onChange={() => toggle(day)} size="sm" isChecked={value.includes(day)} />
      </Flex>
    );
  };

  return (
    <SimpleField<CheckboxProps> name={name} label={fieldLabel} size={size} {...rest}>
      <HStack fontSize="xs" textAlign="center">
        {DAYS_OF_WEEK.map((d) => (
          <DayCheckbox day={d} key={d} />
        ))}
      </HStack>
    </SimpleField>
  );
};
